import type { Mark, ResponseRow } from '../types'

export interface CandidateTally {
  candidateId: string
  ok: number
  maybe: number
  no: number
  /** ○=1, △=0.5, ✕=0 の合計。最有力候補の判定に使う */
  score: number
}

const MARK_WEIGHT: Record<Mark, number> = { ok: 1, maybe: 0.5, no: 0 }

/** 候補ごとに ○△✕ を集計する */
export function tally(candidateIds: string[], responses: ResponseRow[]): CandidateTally[] {
  const map = new Map<string, CandidateTally>()
  for (const id of candidateIds) {
    map.set(id, { candidateId: id, ok: 0, maybe: 0, no: 0, score: 0 })
  }
  for (const r of responses) {
    const t = map.get(r.candidate_id)
    if (!t) continue
    if (r.mark === 'ok') t.ok++
    else if (r.mark === 'maybe') t.maybe++
    else if (r.mark === 'no') t.no++
    t.score += MARK_WEIGHT[r.mark]
  }
  return candidateIds.map((id) => map.get(id)!)
}

/** 最有力候補の candidateId 集合（同点なら複数）。回答が皆無なら空集合 */
export function bestCandidateIds(tallies: CandidateTally[]): Set<string> {
  const max = Math.max(0, ...tallies.map((t) => t.score))
  if (max <= 0) return new Set()
  return new Set(tallies.filter((t) => t.score === max).map((t) => t.candidateId))
}
